import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

/**
 * Legacy BusinessSettings page now redirects to the new admin business settings.
 */
export default function BusinessSettings() {
  const navigate = useNavigate();

  useEffect(() => {
    navigate("/admin/business-settings", { replace: true });
  }, [navigate]);

  return null;
}
